<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>John Amos holds a PhD from the University of California at Berkeley and a JD from the Monterey College of Law. He has taught at university level for over 25 years in the fields of Middle Eastern Politics, Political Sociology, and Political Behaviour. His academic publications include two books, <em>Arab-Israeli Military-Political Relations: Arab Perceptions and the Politics of Escalation</em>, and <em>The Palestinian Resistance; Organization of a Nationalist Movement</em> as well as numerous articles in major academic journals. He has also edited <em>Gulf Security into the Eighties: Perceptual and Strategic Dimensions</em>. He has lived in the Middle East, most notably in Egypt, Lebanon, Libya, and Turkey. He currently practices law.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7a506350